<div class="analytics-card">
  <div class="card-body">
    <h5 class="card-title mb-3">Geographic Threat Origins</h5>
    <kendo-chart>
      <kendo-chart-series>
        <kendo-chart-series-item
          type="pie"
          [data]="geographicThreats()?.geographicThreats || []"
          field="count"
          categoryField="name"
          [labels]="{ visible: true }"
          [autoFit]="true"
        ></kendo-chart-series-item>
      </kendo-chart-series>
      <kendo-chart-legend position="bottom"></kendo-chart-legend>
    </kendo-chart>
  </div>
</div>
